import { render, staticRenderFns } from "./QuoteCommunications.vue?vue&type=template&id=8cdbfdc8&scoped=true"
import script from "./QuoteCommunications.vue?vue&type=script&lang=js"
export * from "./QuoteCommunications.vue?vue&type=script&lang=js"
import style0 from "./QuoteCommunications.vue?vue&type=style&index=0&id=8cdbfdc8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cdbfdc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8cdbfdc8')) {
      api.createRecord('8cdbfdc8', component.options)
    } else {
      api.reload('8cdbfdc8', component.options)
    }
    module.hot.accept("./QuoteCommunications.vue?vue&type=template&id=8cdbfdc8&scoped=true", function () {
      api.rerender('8cdbfdc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/QuoteCommunications.vue"
export default component.exports